import React, { FC } from 'react'
import {
  FilterMultiSelect,
  IFilterMultiSelectOption,
} from 'transfix-ui/components/FilterMultiSelect'
import { FilterIcon } from 'transfix-icons'

interface IRFPTypeFilterProps {
  options?: string[]
  onSelect: (rfpTypes: string[]) => void
}

const typeOptionDefaults: IFilterMultiSelectOption[] = [
  {
    label: 'RFP',
    value: 'rfp',
    selected: false,
  },
  {
    label: 'Reprice',
    value: 'reprice',
    selected: false,
  },
  {
    label: 'Data Analysis',
    value: 'data_analysis',
    selected: false,
  },
  {
    label: 'Shipper Rate Index',
    value: 'shipper_rate_index',
    selected: false,
  },
]

export const RFPTypeFilter: FC<IRFPTypeFilterProps> = ({ options = [], onSelect }) => {
  const typeOptions = typeOptionDefaults.map(typeOption => ({
    ...typeOption,
    selected: options.length === 0 || options.includes(typeOption.value),
  }))
  const onSelectChange = (opts?: IFilterMultiSelectOption[]) => {
    const selectedOptions = opts?.filter(opt => !!opt.selected).map(opt => opt.value) || []
    onSelect(selectedOptions)
  }

  return (
    <FilterMultiSelect
      id='rfp-type-filter'
      label='RFP Type'
      options={typeOptions}
      onSelect={onSelectChange}
      icon={<FilterIcon className='mt1' size='large' />}
      dataTest='rfp-type-filter'
    />
  )
}
